const PREFIX = '[AuthPortal]';

export function logAuthPortal(
  message: string,
  context?: Record<string, unknown>
): void {
  if (context !== undefined) {
    console.warn(PREFIX, message, context);
    return;
  }
  console.warn(PREFIX, message);
}

export function logAuthPortalError(message: string, error: unknown): void {
  console.error(PREFIX, message, error);
}
